"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkWidgetToolbar = void 0;
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var LinkInput_1 = __importDefault(require("../LinkInput"));
var ContextualLinkStyle_1 = __importDefault(require("DreamCoat/Contextual/ContextualLinkStyle/ContextualLinkStyle"));
var react_dom_1 = __importDefault(require("react-dom"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var LinkWidgetToolbar = (function (_super) {
    __extends(LinkWidgetToolbar, _super);
    function LinkWidgetToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleRectObserver = function (targetRect) {
            var _a;
            _this.toolbarPosition = (0, utils_1.getOverlayPosition)({
                overlayRect: (_a = _this.props.toolbarRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(),
                targetRect: targetRect,
                position: "top",
            });
        };
        return _this;
    }
    LinkWidgetToolbar.prototype.componentDidMount = function () {
        this.rectObserver = (0, observe_rect_1.default)(this.props.widgetRef.current, this.handleRectObserver);
        this.rectObserver.observe();
    };
    LinkWidgetToolbar.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.rectObserver) === null || _a === void 0 ? void 0 : _a.unobserve();
    };
    LinkWidgetToolbar.prototype.render = function () {
        var _a, _b;
        var _c = this.props, focus = _c.focus, href = _c.href, blockStore = _c.blockStore, brandStore = _c.brandStore, toolbarRef = _c.toolbarRef, onMouseOutToolbar = _c.onMouseOutToolbar, onMouseOverToolbar = _c.onMouseOverToolbar, showContextualStyle = _c.showContextualStyle, showStyleButton = _c.showStyleButton, toggleShowStyle = _c.toggleShowStyle, toolbarHost = _c.toolbarHost, usingTCDC = _c.usingTCDC, onFocus = _c.onFocus, onBlur = _c.onBlur, removeLink = _c.removeLink, hasError = _c.hasError;
        return react_dom_1.default.createPortal(react_1.default.createElement("span", { contentEditable: false, className: "link-widget__container", onMouseEnter: onMouseOverToolbar, onMouseLeave: onMouseOutToolbar, ref: toolbarRef, style: __assign({}, ((_b = (_a = this.toolbarPosition) === null || _a === void 0 ? void 0 : _a.overlay) !== null && _b !== void 0 ? _b : {})) },
            react_1.default.createElement(LinkInput_1.default, { onInputFocus: onFocus, onInputBlur: onBlur, removeLink: removeLink, focus: focus, href: href, toggleShowStyle: (usingTCDC && toggleShowStyle) || undefined, showContextualStyle: showContextualStyle, showStyleButton: showStyleButton, hasError: hasError }),
            react_1.default.createElement("div", { className: "contextual-link-style", onMouseDown: function (event) { return event.stopPropagation(); } },
                react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 }, showContextualStyle && react_1.default.createElement(ContextualLinkStyle_1.default, { blockStore: blockStore, brandStore: brandStore })))), toolbarHost.current);
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof utils_1.OverlayPositionProps !== "undefined" && utils_1.OverlayPositionProps) === "function" ? _a : Object)
    ], LinkWidgetToolbar.prototype, "toolbarPosition", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkWidgetToolbar.prototype, "handleRectObserver", void 0);
    LinkWidgetToolbar = __decorate([
        mobx_react_1.observer
    ], LinkWidgetToolbar);
    return LinkWidgetToolbar;
}(react_1.default.Component));
exports.LinkWidgetToolbar = LinkWidgetToolbar;
